import styled, { keyframes } from 'styled-components';
import { useLoading } from '../context';
import {getThemeColor} from "../customHostConfigOnClient";

// Fullscreen overlay to block user actions
const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent background */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999; /* Ensure it stays on top of all content */
  pointer-events: ${(props) =>
    props.$isLoading ? 'auto' : 'none'}; /* Disable clicks when not loading */
`;

// Circle spin animation
const spinAnimation = keyframes`
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
`;

const Circle = styled.div`
  width: 50px;
  height: 50px;
  border: 5px solid rgba(255, 255, 255, 0.3);
  border-top: ${(props) => `5px solid ${getThemeColor()}`};
  border-radius: 50%;
  animation: ${spinAnimation} 1s linear infinite;
`;

// Message to display after success/error
const Message = styled.div`
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  background-color: ${({ $status }) => {
    switch ($status) {
      case 'success':
        return 'green';
      case 'warn':
        return 'orange';
      case 'error':
        return 'red';
      default:
        return 'gray';
    }
  }};
  color: white;
  padding: 10px 20px;
  border-radius: 5px;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.2);
  font-size: 18px;
  z-index: 10000; /* Float above the loading spinner */
`;

export const LoadingBar = () => {
  const { isLoading, message, status } = useLoading();

  return (
    <>
      {isLoading && (
        <Overlay $isLoading={isLoading}>
          <Circle />
        </Overlay>
      )}
      {message && <Message $status={status}>{message}</Message>}
    </>
  );
};
